import React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';

import ResetPassword from './components/auth/ResetPassword';
import Organic from './components/signup_partners/OrganicSignup'


/* 
 * Organic signup *
 * 
  <Route exact path="/" render={(props) => (
            <Organic {...props} logo="" account="kinoclub" />)} />
 
 */

export default () => (
    <Layout>
        <Route path="/resetPassword/" component={ResetPassword} />
        {/*<Route exact path="/" render={(props) => (*/}
        {/*    <Organic {...props} logo="" account="kinoclub" isOrganic={true} />)} />*/}
        <Route path="/nt/" render={(props) => (
            <Organic {...props} logo="/img/logos/nt.png" account="NT" requiresAccountID isOrganic={false} />)} />
        <Route path="/vios/" render={(props) => (
            <Organic {...props} logo="/img/logos/vios.svg" partnerName="vios" account="viosStore" requiresAccountID={false} isOrganic={false} />)} />
        <Route path="/panasonic/" render={(props) => (
            <Organic {...props} logo="/img/logos/Panasonic logo.png" partnerName="panasonic" account="panasonicStore" requiresAccountID={false } isOrganic={false} />)} />
        <Route path="/aller/" render={(props) => (
            <Organic {...props} logo="/img/logos/aller-logo.png" partnerName="aller" account="allermediaStore" requiresAccountID isOrganic={false} />)} />
        <Route path="/sandrew/" render={(props) => (
            <Organic {...props} logo="/img/logos/sandrew.png" partnerName="sandrew" account="sandrewStore" requiresAccountID={false} isOrganic={false} />)} />
        <Route path="/vivida/" render={(props) => (
            <Organic {...props} logo="/img/logos/vivida_white.png" partnerName="vivida" account="vividaStore" requiresAccountID={false} isOrganic={false} />)} />
        <Route path="/partner/" render={(props) => (
            <Organic {...props} logo="/img/logos/Kino Club logo.png" partnerName="kinoclubvip" account="kinoclubvipStore" requiresAccountID={false} isOrganic={false} />)} />
        <Route path="/norsk/" render={(props) => (
            <Organic {...props} logo="/img/logos/Norsk Filmdistribusjon.png" partnerName="norsk" account="norskStore" requiresAccountID={false} isOrganic={false} />)} />
        <Route path="/forbrugsforeningen/" render={(props) => (
            <Organic {...props} logo="/img/logos/FBF-logo-navn-vertikal-negativ.png" partnerName="forbrugsforeningen" account="forbrugsforeningenStore" requiresAccountID={false} isOrganic={true} />)} />
        <Route path="/hf/" render={(props) => (
            <Organic {...props} logo="/img/logos/hf.png" partnerName="hf" account="hfStore" requiresAccountID={false} isOrganic={false} />)} />
        <Route path="/lff/" render={(props) => (
            <Organic {...props} logo="/img/logos/LFF.png" partnerName="lff" account="lffStore" requiresAccountID={false} isOrganic={false} />)} />
  </Layout>
);



// WEBPACK FOOTER //
// ./src/App.js